export default __webpack_public_path__ + "static/media/background-checkin.83b0090a.png";